import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e64b857"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-stats-card-container" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = {
  key: 0,
  class: "pl-4 text-caption"
}
const _hoisted_5 = { class: "card-options" }
const _hoisted_6 = {
  key: 1,
  class: "card-body-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_ViewFormAssociatedDevices = _resolveComponent("ViewFormAssociatedDevices")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.form.name) + " ", 1),
          (_ctx.lastUpdated && !_ctx.$vuetify.display.smAndDown)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('i18n.lastUpdate')) + " " + _toDisplayString(_ctx.lastUpdated.toLocaleTimeString('en-GB')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "link-container",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAssociatedDevicesModal && _ctx.openAssociatedDevicesModal(...args)))
          }, _toDisplayString(_ctx.$t('i18n.viewAssociatedDevices')), 1),
          _createElementVNode("div", {
            class: "export-stats-container px-2 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportFormStatsReport && _ctx.exportFormStatsReport(...args)))
          }, [
            _createVNode(_component_v_icon, {
              icon: "mdi-download",
              size: "small"
            }),
            _createVNode(_component_v_tooltip, {
              activator: "parent",
              location: "start"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('i18n.downloadStatsReport')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 0,
            type: "card"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formStatisticsObject.data, (itemStatisticsObject, index) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(itemStatisticsObject.component_name), {
                key: index,
                formName: _ctx.formStatisticsObject.form_name,
                formItem: _ctx.formItemsList[index],
                formItemIndex: index + 1,
                stats: _ctx.formStatisticsObject
              }, null, 8, ["formName", "formItem", "formItemIndex", "stats"]))
            }), 128))
          ]))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.viewAssociatedDevicesIsActive,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.viewAssociatedDevicesIsActive) = $event)),
      "max-width": "60%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ViewFormAssociatedDevices, {
          form: _ctx.form,
          onCloseModal: _ctx.closeEditDeviceModal
        }, null, 8, ["form", "onCloseModal"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}